import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-file-progress-loader',
  templateUrl: './file-progress-loader.component.html',
  styleUrls: ['./file-progress-loader.component.scss'],
  animations: [
      trigger('fadeInOut', [
        state('visible', style({
          opacity: 1,
          transform: 'translateY(0) scale(1)'
        })),
        state('hidden', style({
          opacity: 0,
          transform: 'translateY(-10px) scale(0.8)'
        })),
        transition('visible <=> hidden', [
          animate('2s ease-out')
        ]),
      ])
    ]
})
export class FileProgressLoaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  progress: any = 20
  notificationState = 'visible';
  exportError: boolean;

  exportQueue: any[] = [];


  constructor(private service: ConfigService, private loaderService: LoaderService) {
    this.loaderService.fileProgress$.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      this.progress = value;
      if (value == 100) {

        setTimeout(() => {
          if(this.exportQueue.length == 0) {
          this.hideProgress();
      }}, 1000);
        setTimeout(() => {
          this.showQueueDropdown = false;
          this.loaderService.fileProgress.next(0)
          this.notificationState = "visible"
        }, 2000);
      }

    });

    this.loaderService.exportError$.pipe(takeUntil(this.destroy$)).subscribe((error) => {
      this.exportError = error;
      if (error == true) {

        setTimeout(() => {
          this.loaderService.clearSecondInterval()
          this.hideProgress()
        }, 500);

        setTimeout(() => {
          this.loaderService.fileProgress.next(0)
          this.notificationState = "visible"
          this.loaderService.hideError()
        }, 1000);
      }
    });

    this.loaderService.exportQueue$.pipe(takeUntil(this.destroy$)).subscribe(queue => {
      console.log(queue);

      this.exportQueue = queue;
    });
   }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const dropdownPanel = document.querySelector('.dropdown-panel');
    const dropdownIcon = document.querySelector('.arrow-icon');
    if (dropdownPanel && dropdownIcon && !dropdownPanel.contains(event.target as Node) && !dropdownIcon.contains(event.target as Node)) {
      this.showQueueDropdown = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
  }


  hideProgress() {
    this.notificationState = 'hidden'; // Trigger fade-out on close
    this.showQueueDropdown = false;
  }

  showQueueDropdown = false;

  toggleQueueDropdown() {
    this.showQueueDropdown = !this.showQueueDropdown;
  }

}
